class DesktopNav extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Desktop Header Dropdown
    this.dropdownButtons = this.querySelectorAll(".desktop-nav__dropdown-button");
    this.dropdowns = this.querySelectorAll(".desktop-nav__dropdown");

    this.handleDropdownButtonMouseEnter = this.handleDropdownButtonMouseEnter.bind(this);
    this.handleDropdownButtonMouseLeave = this.handleDropdownButtonMouseLeave.bind(this);
    this.handleDropdownMenuMouseEnter = this.handleDropdownMenuMouseEnter.bind(this);
    this.handleDropdownMenuMouseLeave = this.handleDropdownMenuMouseLeave.bind(this);

    this.closeTimeoutId = null;

    this.dropdownButtons.forEach(button => {
      const dropdown = button.closest(".desktop-nav__dropdown");
      const dropdownMenu = dropdown.querySelector(".desktop-nav__dropdown-menu");

      button.addEventListener("mouseenter", this.handleDropdownButtonMouseEnter);
      button.addEventListener("mouseleave", this.handleDropdownButtonMouseLeave);
      dropdownMenu.addEventListener("mouseenter", this.handleDropdownMenuMouseEnter)
      dropdownMenu.addEventListener("mouseleave", this.handleDropdownMenuMouseLeave)
    })

    this.level2Buttons = this.querySelectorAll("[data-nav-btn-level='2']");
    this.level3Menus = this.querySelectorAll(".desktop-nav__level3-menu");

    this.openLevel3Menu = this.openLevel3Menu.bind(this);

    this.level2Buttons.forEach(button => {
      button.addEventListener("mouseenter", this.openLevel3Menu);
    })
  }

  disconnectedCallback() {
    this.level2Buttons.forEach(button => {
      button.removeEventListener("mouseenter", this.openLevel3Menu);
    })

    this.dropdownButtons.forEach(button => {
      const dropdown = button.closest(".desktop-nav__dropdown");
      const dropdownMenu = dropdown.querySelector(".desktop-nav__dropdown-menu");
      button.removeEventListener("mouseenter", this.handleDropdownButtonMouseEnter);
      button.removeEventListener("mouseleave", this.handleDropdownButtonMouseLeave);
      dropdownMenu.removeEventListener("mouseenter", this.handleDropdownMenuMouseEnter)
      dropdownMenu.removeEventListener("mouseleave", this.handleDropdownMenuMouseLeave)
    })
  }

  _setDropdownState(state, dropdown) {
    dropdown.dataset.dropdownState = state;
    
    if (state === "close") {
      delete dropdown.dataset.source;
    }
  };

  handleDropdownButtonMouseEnter(e) {
    const button = e.target;
    const dropdown = button.closest(".desktop-nav__dropdown");
    const dropdownMenu = dropdown.querySelector(".desktop-nav__dropdown-menu");
    if (!dropdownMenu) return;

    clearTimeout(this.closeTimeoutId); // Cancel any pending close
    
    // Mark that we entered via the button (required for rule enforcement)
    dropdown.dataset.source = "button";
    
    // Close other open dropdowns
    this.dropdowns.forEach(d => {
      if (d !== dropdown && d.dataset.dropdownState === "open") {
        this._setDropdownState("close", d); // This will run on "d" if moved below, but here we just set state
        // Note: The setDropdownState helper above targets "this" dropdown. 
        // Let"s fix the closure for others:
        d.dataset.dropdownState = "close";
        delete d.dataset.source;
      }
    });

    this._setDropdownState("open", dropdown);
  }

  handleDropdownButtonMouseLeave(e) {
    const button = e.target;
    const dropdown = button.closest(".desktop-nav__dropdown");
    const dropdownMenu = dropdown.querySelector(".desktop-nav__dropdown-menu");
    if (!dropdownMenu) return;

    // If mouse is already over the menu, do nothing (transition is in progress)
    if (dropdownMenu.matches(":hover")) {
      console.log("Menu Hovered");
      return;
    }

    // Start 1-second delay to close
    this.closeTimeoutId = setTimeout(() => {
      // Re-check hover status at the moment the timer fires
      if (!dropdownMenu.matches(":hover")) {
        this._setDropdownState("close", dropdown);
      }
    }, 400);
  }

  handleDropdownMenuMouseEnter(e) {
    clearTimeout(this.closeTimeoutId);
    this.closeTimeoutId = null;

    const button = e.target;
    const dropdown = button.closest(".desktop-nav__dropdown");

    // Only allow open if we came from the button
    if (dropdown.dataset.source !== 'button') {
      if (dropdown.dataset.dropdownState === 'open') {
         this._setDropdownState('close', dropdown);
      }
      return;
    }

    this._setDropdownState('open', dropdown);
  }
  
  handleDropdownMenuMouseLeave(e) {
    const button = e.target;
    const dropdown = button.closest(".desktop-nav__dropdown");
    const dropdownMenu = dropdown.querySelector(".desktop-nav__dropdown-menu");

    if (!button.matches(':hover') && !dropdownMenu.matches(':hover')) {
      this._setDropdownState('close', dropdown);
    }
  }

  openLevel3Menu(e) {
    const button = e.target;
    const level2Title = button.dataset.level2Title;

    // deactivate all level2 buttons
    this.level2Buttons.forEach(button => {
      button.dataset.active = false;
    })
    button.dataset.active = true;

    // close all level3 menus
    this.level3Menus.forEach(menu => {
      menu.dataset.visibility = "hidden";
      if (menu.dataset.level2Title === level2Title) {
        menu.dataset.visibility = "show";
      }
    })
  }
}

customElements.define("desktop-nav", DesktopNav);
